(function() {

  function typeTabSwitch() {
    $('.type__item').click(function() {
      var type = $(this).data('type');
      $('.type__item').removeClass('is-current');
      $(this).addClass('is-current');
      $('.js-type').removeClass('is-list').removeClass('is-card')
      $('.js-type').addClass('is-'+ type +'')
    })
  }


  const isAboutPage = $('.about').length;
  if(isAboutPage) {
    typeTabSwitch();
  }
})();